export default __webpack_public_path__ + "static/media/The Silent Lullaby.9126d1ce.jpg";